module.exports = __webpack_public_path__ + "media/images/flags/4x3/qat-40687d3e535351956c8747d37ee2e039.svg";